import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserAsset } from '@models/dashboard.model';
import { Notification } from '@models/notifications.model';
import { TranslationBundle } from '@models/shopping.model';
import { UserProfile } from '@models/user-profile.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { NotificationsService } from '@services/notifications/notifications.service';
import { PendoService } from '@services/pendo/pendo.service';
import { SessionService } from '@services/session/session.service';
import { Subscription } from 'rxjs';
import { NotificationsComponent } from 'tangoe-design-system';

import { MyAssetsComponent } from '../my-assets/my-assets.component';
import { MyOrdersComponent } from '../my-orders/my-orders.component';
import { OrderCenterComponent } from '../order-center/order-center.component';

@Component({
  selector: 'ts-dashboard-index',
  templateUrl: './dashboard-index.component.html',
  imports: [
    TranslationPipe,
    OrderCenterComponent,
    MyOrdersComponent,
    MyAssetsComponent,
    NotificationsComponent
  ]
})
export class DashboardIndexComponent implements OnInit, OnDestroy {
  my_assets: UserAsset[];
  dashboard_notifications: Notification[] = [];
  store_notifications: Notification[] = [];
  storage_key: string = NotificationsService.DASHBOARD_NOTIFICATIONS_STORAGE_KEY;
  translations: TranslationBundle[];
  private subscriptions: Subscription = new Subscription();

  constructor(
    private notifications_svc: NotificationsService,
    private pendo_svc: PendoService,
    private session_svc: SessionService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.notifications_svc.dashboardNotifications(this.storage_key).subscribe({
        next: (notifications: Notification[]) => {
          this.dashboard_notifications = notifications;
        }
      })
    );
    const userProfile: UserProfile | undefined = this.session_svc.getUserProfile();
    if (userProfile) this.pendo_svc.initPendo(userProfile);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getLoggedinUserName() {
    return this.session_svc.getUserName();
  }

  markNotificationAsRead(event: { notification: Notification; type: string }): void {
    this.notifications_svc.markAsRead(event.notification, event.type);
  }
}
